import { useState, useCallback } from 'react';
/**
 * A hook to manage step navigation in multi-step forms or wizards
 */
export const useStepNavigation = ({ totalSteps, initialStep = 1, stepValidations = {}, }) => {
    const [currentStep, setCurrentStep] = useState(initialStep);
    const isLastStep = currentStep === totalSteps;
    const isFirstStep = currentStep === 1;
    const handleNext = useCallback(() => {
        if (currentStep < totalSteps) {
            // Validate current step before proceeding if validation function exists
            const validationFn = stepValidations[currentStep];
            if (validationFn && !validationFn()) {
                return; // Don't proceed if validation fails
            }
            setCurrentStep(currentStep + 1);
        }
    }, [currentStep, totalSteps, stepValidations]);
    const handlePrevious = useCallback(() => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    }, [currentStep]);
    const goToStep = useCallback((step) => {
        if (step >= 1 && step <= totalSteps) {
            setCurrentStep(step);
        }
    }, [totalSteps]);
    return {
        currentStep,
        isLastStep,
        isFirstStep,
        handleNext,
        handlePrevious,
        goToStep,
    };
};
